import React from "react";
import { Flame } from "lucide-react";
import { FornoItem } from "../../../services/fornoService";
import FornoItemCard from "./FornoItemCard";

interface FornoColunaProps {
  items: FornoItem[];
  colunaIndex: number;
  totalColunas: number;
  tick: number;
  finalizandoId: number | null;
  canFinalizar: boolean;
  onFinalizar: (id: number) => void;
  onMover: (id: number, direcao: "esquerda" | "direita") => void;
}

const FornoColuna: React.FC<FornoColunaProps> = ({
  items,
  colunaIndex,
  totalColunas,
  tick,
  finalizandoId,
  canFinalizar,
  onFinalizar,
  onMover,
}) => {
  return (
    <div className="flex w-[320px] shrink-0 flex-col rounded-xl border border-neutral-200 bg-neutral-50 sm:w-[340px]">
      <div className="flex items-center gap-2 border-b border-neutral-200 px-4 py-3">
        <Flame size={18} className="text-orange-500" />
        <h2 className="text-sm font-bold text-neutral-800">
          Forno {colunaIndex + 1}
        </h2>
        <span className="ml-auto rounded-full bg-neutral-200 px-2 py-0.5 text-xs font-semibold text-neutral-600">
          {items.length}
        </span>
      </div>

      <div className="flex flex-col gap-3 overflow-y-auto p-3">
        {items.map((item) => (
          <FornoItemCard
            key={item.id}
            item={item}
            tick={tick}
            isFirstColuna={colunaIndex === 0}
            isLastColuna={colunaIndex === totalColunas - 1}
            finalizandoId={finalizandoId}
            canFinalizar={canFinalizar}
            onFinalizar={onFinalizar}
            onMover={onMover}
          />
        ))}
      </div>
    </div>
  );
};

export default FornoColuna;
